"use client";

import { openCartDrawer, useCart } from "../../lib/cart-store";

/**
 * Header cart control. Opens the slide-in drawer rather than navigating to
 * /cart — a shopper mid-collection should be able to check their bag and keep
 * browsing. /cart is still reachable from inside the drawer and is still where
 * checkout lives.
 *
 * A thin-stroke shopping cart drawn in currentColor, so it follows the header's text
 * colour on both the dark hero and the paper pages. The count badge only
 * appears once there is something in the bag; an empty "0" reads as noise.
 */
export default function CartLink({ className = "" }: { className?: string }) {
  const cart = useCart();
  const count = cart.status === "loading" ? 0 : cart.count;
  return (
    <button
      type="button"
      onClick={openCartDrawer}
      aria-label={`Open cart, ${count} ${count === 1 ? "item" : "items"}`}
      className={`relative inline-flex h-9 w-9 items-center justify-center ${className}`}
    >
      <svg
        viewBox="0 0 24 24"
        width="22"
        height="22"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
      >
        <path d="M2.5 3h2.2l2.4 11.3a1.8 1.8 0 0 0 1.8 1.4h8.9a1.8 1.8 0 0 0 1.7-1.3L21 7.2H5.6" />
        <circle cx="9.2" cy="20" r="1.1" />
        <circle cx="17.6" cy="20" r="1.1" />
      </svg>
      {count > 0 && (
        <span
          aria-hidden="true"
          className="absolute -right-0.5 -top-0.5 flex h-[17px] min-w-[17px] items-center justify-center rounded-full bg-gold px-1 text-[10px] font-semibold leading-none tracking-normal text-ink"
        >
          {count > 99 ? "99+" : count}
        </span>
      )}
    </button>
  );
}
